import React from "react";
import { EditableTable, createQuickRenderer } from "../../common";
import {
  useKycTaxResidenceTable,
  type IKycTaxResidenceTableProps,
} from "./useKycTaxResidenceTable";

export const KycTaxResidenceTable: React.FC<IKycTaxResidenceTableProps> = props => {
  const { taxResidences, taxResidenceColumns, handleChange, crossIntl } = useKycTaxResidenceTable(
    props,
    createQuickRenderer,
  );
  return (
    <EditableTable
      value={taxResidences}
      onChange={handleChange}
      columns={taxResidenceColumns}
      title={crossIntl["kyc.questionnaire.taxresidence.table.title"]}
      addButtonText={crossIntl["shareholder.button.add"]}
      minRows={0}
    />
  );
};
